import Component from '../../../classes/Component';
import {$events} from "../../../helpers/events";
import {$dom} from "../../../helpers/dom";
import variables from "../../../variables";

const sectionAttr = 'data-menu-highlight-section';
const sectionSelector = `[${sectionAttr}]`
const highlightedClassName = 'is-highlighted';
const menuDropdownId = 'js-landing-header-menu-dropdown';

export default function () {
    const $Page = this;

	return new Component({
		name: 'menuHighlight',
		requiredTargets: sectionSelector,
		onInit() {
		    const {Dropdown} = $Page.bootstrap;
		    const menuDropdownEl = $dom.get('#'+menuDropdownId);
            const menuDropdownInstance = Dropdown.getOrCreateInstance(menuDropdownEl);
            const menuDropdownInner = $dom.get('.dropdown-menu', menuDropdownEl)

            this.handleScroll = () => {
                const scrollY = window.pageYOffset + variables.dom.header.offsetHeight;

                $dom.each(this.targets, target => {

                    const sectionHeight = target.offsetHeight;
                    const sectionTop = target.offsetTop - 100;
                    const sectionId = target.getAttribute(sectionAttr);
                    const currentLink = $dom.get(`a[href="#${sectionId}"]`);

                    if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
                        $dom.addClass(currentLink, highlightedClassName)
                    } else {
                        $dom.removeClass(currentLink, highlightedClassName)
                    }
                });

                if ($dom.hasClass(menuDropdownInner, 'show'))
                    menuDropdownInstance.hide();

            }

		    $events.add('scroll', window, this.handleScroll)
        },
		onDestroy() {
            $events.remove('scroll', window, this.handleScroll)
        }
	})
}
